(() => {
  function init() {
    document.querySelectorAll('[data-oc-site-header]').forEach(header => {
      if (header.dataset.ocReady) return;
      header.dataset.ocReady = 'true';
      const dialog = header.querySelector('.oc-mobile-dialog');
      const opener = header.querySelector('[data-oc-menu-open]');
      let priorOverflow = '';
      const restore = () => { document.body.style.overflow = priorOverflow; opener.setAttribute('aria-expanded', 'false'); };
      opener.addEventListener('click', () => {
        priorOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
      });
      header.querySelector('[data-oc-menu-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', restore);
      dialog.addEventListener('click', event => {
        const r = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
      });
      const mega = header.querySelector('.oc-mega-menu');
      document.addEventListener('click', event => {
        if (mega.open && !mega.contains(event.target)) mega.open = false;
      });
      mega.addEventListener('keydown', event => {
        if (event.key === 'Escape') { mega.open = false; mega.querySelector('summary').focus(); }
      });
      const desktop = matchMedia('(min-width:990px)');
      desktop.addEventListener('change', () => { if (desktop.matches && dialog.open) dialog.close(); if (!desktop.matches) mega.open = false; });
    });
    document.querySelectorAll('[data-oc-site-footer]').forEach(footer => {
      if (footer.dataset.ocReady) return;
      footer.dataset.ocReady = 'true';
      const desktop = matchMedia('(min-width:990px)');
      const groups = footer.querySelectorAll('.oc-footer-group');
      const set = () => groups.forEach(group => { group.open = desktop.matches; });
      set();
      desktop.addEventListener('change', set);
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => { if (desktop.matches) event.preventDefault(); }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
